/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$( document ).ready(function() { 
  
  var $productImage;
  var $uploadedImage;

  var productForm = document.querySelector('form[action*="/cart/add"]');

    productForm.addEventListener('upload:added', function(e){
    $.cookie("show-size-popup", "show");
    var file = e.detail;

    
    setCanvasSize();
    getImageDetail(file.url);

  });
  
  $("#alert-window #hide-cookie-controller").click( function(){
    $.cookie("show-size-popup", "hide");  
    closePopup();    
  });


});

document.addEventListener('variant:changed', function(event) {
   var variant = event.detail.variant; // Gives you access to the whole variant details
 
  setTimeout(function(){ 
    console.log("First try");
    setCanvasSize();
    
    if($('#canvas-wrapper #canvas').width() == 0){
      setTimeout(function(){ 
        console.log("Second try");
        setCanvasSize();
        if($('#canvas-wrapper #canvas').width() == 0){
          setTimeout(function(){ 
            console.log("Third try");
            setCanvasSize();
          }, 3000);
        }
      }, 3000);
    }
  }, 3000);
  
  
  var urlOfImage = $(".product-form [name='properties[UPLOAD]']").val();
  getImageDetail(urlOfImage);
});

function setCanvasSize(){
  if($('.product-form__variants .size_swatches').length > 0 && $('#canvas-preview-img').length > 0 ){
    var radioName = $('.product-form__variants .size_swatches').data('name');
    var selected_size = $('.product-form__variants .size_swatches').find('input[name="'+ radioName +'"]:checked').val();
    var selected_size_arr = selected_size.split('cm')[0].split('x');
    var width = selected_size_arr[0];
    var height = selected_size_arr[1];
    var canvasWidth = $('.preview-wrapper .preview-wrapper-width').width();
    var canvaseHeight = canvasWidth*height / width;
    
    if(canvasWidth > 0  && canvaseHeight > 0){
      $('#canvas-preview-img').height(canvaseHeight);
      $('#canvas-preview-img').width(canvasWidth);
      
    
    }
    
  }
}

function getImageDetail(url){
  if($(".product-form [name='properties[UPLOAD]']").length){
    var tmpImg = new Image();
    tmpImg.src = url
    $(tmpImg).on('load',function(){
      var orgWidth = tmpImg.width;
      var orgHeight = tmpImg.height;
      showPopup(orgWidth, orgHeight);
    });
  }
  
}

function closePopup(){
    $('#alert-popup-ovaelay').fadeOut();
    $('#alert-window').fadeOut();
    $('#size-info-text-container').text("* "+inforStr+" !");
    $('#size-info-text-container').show();
  }
  
var inforStr = "";
  function showPopup(widthImg, heightImg){
    var ratio = widthImg / heightImg ;
    ratio = ratio.toFixed(2);
  
    
    var radioName = $('.product-form__variants .size_swatches').data('name');
    var selected_size = $('.product-form__variants .size_swatches').find('input[name="'+ radioName +'"]:checked').val();
    var selected_size_arr = selected_size.split('cm')[0].split('x');
    var width = selected_size_arr[0];
    var height = selected_size_arr[1];
    
    var optionRation = width / height;
    optionRation = optionRation.toFixed(2);
    console.log(ratio);
    console.log(optionRation);
    
    
    if(ratio != optionRation){
      
         var sizeOption = $('.size_swatches .block-swatch');
      if(sizeOption.length > 0){
        
        var sizesuggetion = "" ;
        for(var k=0; k< sizeOption.length; k++){
          var elemntValue = $(sizeOption[k]).find('.block-swatch__radio').val();        
          var _selected_size_arr = elemntValue.split('cm')[0].split('x');
          var _width = _selected_size_arr[0];
          var _height = _selected_size_arr[1];
           var _optionRation = _width / _height;
          _optionRation = _optionRation.toFixed(2);
          
          if(ratio == _optionRation){
            sizesuggetion = sizesuggetion + ", " + elemntValue;
          }
          
          
        }
        
        if(sizesuggetion.length > 0){
          sizesuggetion = sizesuggetion.substring(2);
        }
        
        inforStr =  'For best results, we advise you to take the size "'+sizesuggetion+'". Otherwise, your image might be cropped by our design team';
        
        if(typeof $.cookie('show-size-popup') == 'undefined' || $.cookie('show-size-popup') == 'show'){
          $('#size-info-text-container').hide();
          $('#size-info-text-container').text("");
          
          $('#alert-window #alert-ext').text(inforStr);
          $('#alert-popup-ovaelay').fadeIn();
          $('#alert-window').css("display", "flex").hide().fadeIn();
        }else{
          $('#size-info-text-container').text("* "+inforStr+" !");
          $('#size-info-text-container').show();
        }
      }
    }else{
        $('#size-info-text-container').hide();
        $('#size-info-text-container').text("");
      }
    
    
   
  }